import { DeviceService } from '../../../services/device.service'
import ChangeDate from '@/components/ChangeDate.vue'
import _ from 'lodash'
export default {
  components: { ChangeDate },
  methods: {
    canApprove(status, managerIdInventory) {
      return (
        status === 'NEW' && this.dataPermission.includes('CNPS_DEVICE_ORDER_RETURN_APPROVE_REJECT')
      )
    },
    canReject(status, managerIdInventory) {
      return (
        status === 'NEW' && this.dataPermission.includes('CNPS_DEVICE_ORDER_RETURN_APPROVE_REJECT')
      )
    },
    canCancel(status, userCreator, managerIdInventory) {
      return status === 'NEW' && this.dataPermission.includes('CNPS_DEVICE_ORDER_RETURN_CANCEL')
    },
    canEdit(status, userCreator) {
      return status === 'NEW' && this.dataPermission.includes('CNPS_DEVICE_ORDER_RETURN_UPDATE')
    },
    canCoppy(status, userCreator) {
      return ['REJECTED', 'CANCELLED'].includes(status)
    },
    canEditDate(status, userCreator) {
      return (
        ['APPROVED'].includes(status) &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_CHANGE_DATE_COMPLETE')
      )
    },
    async inTicket(id) {
      this.loading = true
      try {
        const res = await DeviceService.detailImportWarehouse(id)
        const data = res.data
        const devicesGroup = _.groupBy(res.data.devices, 'categoryName')
        data.devicesGroup = Object.values(devicesGroup)
        data.devicesTotalAmount = data.devices.reduce((t, i) => t + i.price, 0)
        await DeviceService.inImportTicket({ data })
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    detailItem(id) {
      const routeData = this.$router.resolve({
        path: `/return-request/detail/${id}`,
      })
      window.open(routeData.href, '_blank')
    },
    approveItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn duyệt phiếu hoàn hàng ${item.billNumber} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Duyệt phiếu hoàn hàng',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.approveReturnRequest({
              id: item.id,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Duyệt phiếu hoàn hàng ${item.billNumber} thành công`)
              this.fetchData()
            } else this.showErr(res.message || `Duyệt phiếu hoàn hàng ${item.billNumber} thất bại`)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    rejectItem(item) {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('label', { class: 'f12 mb-2' }, 'Lý do*'),
        h('textarea', {
          ref: 'rejectValue',
          class: 'form-control f12',
          attrs: { placeholder: 'TB không hợp lệ', rows: 3 },
        }),
      ])
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Từ chối phiếu hoàn hàng',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            console.log(this.$refs.rejectValue.value)
            console.log(item.id)
            const res = await DeviceService.rejectReturnRequest({
              id: item.id,
              reasonReject: this.$refs.rejectValue.value,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Từ chối phiếu hoàn hàng ${item.billNumber} thành công`)
              this.fetchData()
            } else {
              this.showErr(res.message || `Từ chối phiếu hoàn hàng ${item.billNumber} thất bại`)
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancelItem(item) {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('label', { class: 'f12 mb-2' }, 'Lý do*'),
        h('textarea', {
          ref: 'rejectValue',
          class: 'form-control f12',
          attrs: { placeholder: 'TB không hợp lệ', rows: 3 },
        }),
      ])
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Huỷ phiếu hoàn hàng',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.cancelReturnRequest({
              id: item.id,
              reasonReject: this.$refs.rejectValue.value,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Huỷ phiếu hoàn hàng ${item.billNumber} thành công`)
              this.fetchData()
            } else this.showErr(res.message || `Huỷ phiếu hoàn hàng ${item.billNumber} thất bại`)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    editItem(id) {
      this.$router.push({
        path: `/return-request/edit/${id}`,
      })
    },
    copyItem(coppyFrom) {
      this.$router.push({
        name: 'addReturnRequest',
        params: { coppyFrom },
      })
    },
    editDate() {
      this.$bvModal.show('change-date')
    },
  },
}
